module.exports = __webpack_public_path__ + "img/stat_01_icon.ac6b8f53.png";